export const DeliveryType = Object.freeze({
  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE',
  MAILED: 'MAILED',
  BULK_PHYSICAL: 'BULK_PHYSICAL'
})
